export function parseQueryParamAsEnum<T extends string>(
    enumDict: Record<string, T>,
    param: string | string[] | undefined,
    defaultValue: T,
): T {
    const value = param as T;

    return Object.values(enumDict).includes(value) ? (value as T) : defaultValue;
}
